import { defineMessages } from 'react-intl-next';

export const i18n: {
	assetsSchema: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assetsFilterAssetsSchemaPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assetsFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assetsFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assetsIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	assetsSchema: {
		id: 'search-page.filters.names.assets-schema',
		defaultMessage: 'Schema',
		description: 'Label for filtering by assets schema',
	},
	assetsFilterAssetsSchemaPlaceholder: {
		id: 'search-page.assets.filter.assets-schema.placeholder',
		defaultMessage: 'Find schemas',
		description: 'Placeholder for assets schema filter search input',
	},
	assetsFilterLabelSelected: {
		id: 'search-page.assets.filter.assets-schema.label.selected',
		defaultMessage: 'Selected',
		description: 'Label for selected assets schemas',
	},
	assetsFilterLabelUnselected: {
		id: 'search-page.assets.filter.assets-schema.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Label for suggested assets schemas',
	},
	assetsIconLabel: {
		id: 'search-page.assets.filter.assets-schema.icon.label',
		defaultMessage: 'Assets schema filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Confluence',
	},
});
